import moment from 'moment';
import requestService from 'viralstyle-ui/src/requestService';
import storage from 'viralstyle-ui/src/storage';
import hateoas from 'viralstyle-ui/src/hateoas';

import router from '@/router';
import config from 'config';
import { CustomerModel } from 'sales-flow-ui/domains/checkout/store/models';

let pendingTokenPromise = null;

export const async = async ({ state, dispatch, commit }, promise) => {
  let backgroundRequest = false;

  if (Object.keys(promise).length) {
    backgroundRequest = promise.backgroundRequest;
    promise = promise.promise;
  }

  let promiseObj = {
    id: state.promiseCount,
    promise: promise(),
  };

  if (!backgroundRequest) {
    commit('addPromise', promiseObj);
  }

  try {
    let response = await promiseObj.promise;

    if (!backgroundRequest) {
      commit('removePromise', promiseObj);
    }

    commit('initializeUserTimeout', dispatch);

    return response;
  } catch (error) {
    commit('removePromise', promiseObj);

    // only log the error if its not an invalid login, no need to flood sentry with bad login attempts
    if (error.requiresLogin && !error.nonPublicScope) {

      // if token is invalid, get a new one, wait for it to come back and then rerun the request
      // TODO probably have to handle logging out a logged in user here
      if (state.route.name === 'designer' && state.userLoggedIn) {
        router.push({ name: 'signIn' });
      } else {
        if (!pendingTokenPromise) {
          pendingTokenPromise = dispatch('getPublicToken');
        }

        await pendingTokenPromise;

        pendingTokenPromise = null;

        dispatch('logout', true);

        return dispatch('async', promise);
      }
      // silently fail
    } else {
      let errorData = await dispatch('logError', error);

      // set this flag so on the global exception catch all, we dont log this
      error.logged = true;

      if (errorData) {
        error.data = errorData;
      }
    }

    throw error;
  }
}

export const getPublicToken = async ({ dispatch }) => {
  return dispatch('async', () => requestService.get(`${config.APP_PROTOCOL}:${config.API_URL}${config.API_ROOT}/v3/token`, false));
};

export const getCurrencyInfo = async ({ rootState, state, dispatch, commit }, country) => {
  let url = hateoas.url('get_customer_currency');

  if (country) {
    url += `?country_iso=${country}`
  }

  let response = await dispatch('get', url);

  commit('updateState', {
    object: state,
    property: 'currencyInfo',
    value: response.data,
  });

  if (!country && rootState.route.name !== 'profileDefaultAddress') {
    commit('updateState', {
      object: state.checkout.customer,
      property: 'country',
      value: state.currencyInfo.country_iso,
    });
  }

  return response;
};

export const navigateToRecentCampaignOrMarketplace = ({}, doNotReplace) => {
  let recentCampaign = storage.get('recent-campaign');

  if (recentCampaign) {
    doNotReplace ? router.push({ name: 'sales', params: { ...recentCampaign } }) : router.replace({ name: 'sales', params: { ...recentCampaign } });
  } else {
    doNotReplace ? router.push({ name: 'marketplace' }) : router.replace({ name: 'marketplace' });
  }
};

export const campaignFallbackOrMarketplace = ({ dispatch }, { replace, campaignFallback }) => {
  if (campaignFallback) {
    dispatch('navigateToRecentCampaignOrMarketplace', !replace);
  } else {
    replace ? router.push({ name: 'marketplace' }) : router.replace({ name: 'marketplace' });
  }
};

export const navigateToLastListing = ({ dispatch }, { replace = false, campaignFallback = false } = { replace: false, campaignFallback: false }) => {
  let lastListing = storage.get('last-listing-url');

  if (lastListing) {
    let duration = moment.duration(moment().diff(lastListing.time)),
      hours = duration.asHours();

    if (hours <= 24) {
      replace ? router.replace(lastListing.url) : router.push(lastListing.url);
    } else {
      storage.remove('last-listing-url');

      dispatch('campaignFallbackOrMarketplace', { replace, campaignFallback })
    }
  } else {
    dispatch('campaignFallbackOrMarketplace', { replace, campaignFallback })
  }
};

export const logoutImpersonation = async ({ state, dispatch }, noClose) => {
  let response = await dispatch('del', state.checkout.customer._links.end_impersonation_session.href);

  if (!noClose) {
    window.close();
  }

  await dispatch('getUserInfo');

  return response;
};